import "../../setting/Salary/payroll.css";
import React, { useCallback, useEffect, useState } from "react";
import ButtonCom from "../../components/button/button";
import { Form, Col, Row, Button } from "react-bootstrap";
import { IoIosAdd } from "react-icons/io";
import { FiInfo } from "react-icons/fi";
import { RiDeleteBin5Line } from "react-icons/ri";
import { LiaRupeeSignSolid } from "react-icons/lia";
import { BiRupee } from "react-icons/bi";
import { IoInformationCircleOutline } from "react-icons/io5";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import FormControl from "@mui/material/FormControl";
import Switch from "@mui/material/Switch";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  commonGetData,
  commonGetDataOne,
  commonGetDataTwo,
  commonGetDataThird,
  initCommonState,
  commonSaveData,
} from "../../redux/slices/commonSlice";
import { Link, useNavigate } from "react-router-dom";
import {
  getAllowanceListPath,
  getDeductionListPath,
  getEmpPfVariableListPath,
  updatePayrollModelPath,
  getCalendarMonthListPath,
} from "../../services/config";
import { splitCamelCase } from "../../services/commonServices";
import { ArrowBack } from "@mui/icons-material";
import Widgets from "../../components/Widgets";

const customStyles = {
  control: (provided) => ({
    ...provided,
    border: "none", // Remove border
    boxShadow: "none",
    backgroundColor: "transparent", // Change control background color
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "transparent", // Dropdown menu background
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#080808" : "#080808", // Hover and normal background
    color: "#fff",
  }),
};

const animatedComponents = makeAnimated();
const SalaryTemplate = ({ onChange }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.common);

  const user = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
    : null;

  const [validated, setValidated] = useState(false);
  const [allowance] = useState([
    {
      value: 1,
      label: "Special Allowance",
    },
    {
      value: 2,
      label: "Dearness Allowance",
    },
    {
      value: 3,
      label: "Add Allowance +",
    },
  ]);
  const [calendarMonthList, setCalendarMonthList] = useState([
    {
      id: 1,
      label: "Calendar Month",
      value: "CalendarMonth",
    },
    {
      id: 2,
      label: "30 Days Month",
      value: "30DaysMonth",
    },
  ]);

  // {
  //   id: 3,
  //   label: "Custom Date Range",
  //   value: "CustomDateRange",
  // },

  const [deductionApiList, setDeductionApiList] = useState([]);
  const [pfVariableList, setPfVariableList] = useState({});
  const [saveData, setSaveData] = useState({
    payrollModelId: "",
    basicPay: "",
    basicPayType: "",
    basicType: "",
    hraPay: "",
    hraType: "",
    hraPayType: "",
    otherAllowance: "",
    otherAllowanceType: "",
    otherType: "",
    templateName: "",

    employerPf: "",
    employerPfFixedOrPro: "",

    employerESI:
      "3.25% on Gross Salary if the Gross Salary is less than Rs. 21,000",
    adminCharges: "",
    edliCharges: "",
    empPfChange: "",

    employeePf: "",
    employeePfFixOrPro: "",

    employeeESI:
      "0.75% on Gross Salary if the Gross Salary is less than Rs. 21,000",
    professionalTax:
      "Max Rs. 200 will be deducted if the Gross Salary is 25000 or above",
    lwf: "",
    lwfState: "",
    lwfDeductionFrequency: "",
    preEarnings: "",
    preAllowance: "",
    attendanceCycle: "",
    payDays: "",

    employerLwf: "",
    employerLwfState: "",
    employerLwfDeductionFrequency: "",
  });

  const handleToggleChange = (event) => {
    setSaveData((pre) => ({
      ...pre,
      [event.target.name]: event.target.value,
    }));
  };
  const [customEmpPF, setCustomEmpPF] = useState(false);
  const [earnings, setEarnings] = useState([]);
  const [deductions, setDeductions] = useState([]);

  useEffect(() => {
    const payrollData = JSON.parse(localStorage.getItem("payroll-data")) || {};
    if (payrollData) {
      const earningsArray = payrollData.allowanceList?.map((val, idx) => {
        const keys = Object.keys(val)[0];
        const calcArr = val[keys].split("|");
        return {
          id:
            keys === "Special Allowance"
              ? 1
              : keys === "Dearness Allowance"
              ? 2
              : 3,
          head: keys,
          calculation: calcArr[0],
          calculationType: calcArr[2],
          type: calcArr[1],
          salaryType: calcArr[3],
        };
      });

      const actualEarnings = earningsArray?.filter(
        (row) => row.head != "Other Allowance"
      );
      const otherAllowanceEarnings = earningsArray?.filter(
        (row) => row.head == "Other Allowance"
      );

      setEarnings(actualEarnings);


      // const filteredData = payrollData.allowanceList
      //   ?.filter((obj) => obj.hasOwnProperty("Other Allowance"))[0]
      //   ["Other Allowance"].split("|");

      const filteredData = payrollData.allowanceList
        ?.filter((obj) => obj.hasOwnProperty("Other Allowance"))[0]
        ["Other Allowance"].split("|");

      const newAllowanceArray = payrollData.newAllowanceList?.map(
        (val, idx) => {
          const keys = Object.keys(val)[0];
          const calcArr = val[keys].split("|");
          return {
            id: idx + 1,
            head: keys,
            calculation: calcArr[0],
            calculationType: calcArr[2],
            type: calcArr[1],
          };
        }
      );
      setDeductions(newAllowanceArray);

      const splittedValue = payrollData.attendanceCycle?.split("|");

      const attendanceCycleType = splittedValue ? splittedValue[0] : "";

      const dateType = splittedValue ? splittedValue[1] : "";

      const splittedDate = dateType ? dateType?.split("-") : "";

      setCalendarType(
        // FixedDate
        attendanceCycleType == "CalendarMonth"
          ? "CalendarMonth"
          : attendanceCycleType == "CustomDate"
          ? "CustomDateRange"
          : "30DaysMonth"
      );

      const splittedBasicPay = payrollData ? payrollData.basicPay.split("|") : "";
      const splittedHraPay = payrollData ? payrollData.hraPay.split("|") : "";

      setSaveData((previewState) => ({
        ...previewState,
        payrollModelId: payrollData.payrollModelId,
        attendanceCycle:
          attendanceCycleType == "CalendarMonth"
            ? "Calendar Month"
            : attendanceCycleType == "CustomDate"
            ? "Custom Date Range"
            : "30 Days Month",

        payDays: payrollData.payDays,

        basicPay: splittedBasicPay[0],
        basicType: splittedBasicPay[1],
        basicPayType: splittedBasicPay[2],

        hraPay: splittedHraPay[0],
        hraPayType: splittedHraPay[1],
        hraType: splittedHraPay[2],

        // otherAllowanceType: filteredData[2],
        // otherType: filteredData[1],
        // otherAllowance: filteredData[0],

        otherAllowanceType: filteredData[0],

        templateName: payrollData.payrollModelName,

        employerPfFixedOrPro: payrollData.employerPf.split("|")[0],
        employerPf: payrollData.employerPf.split("|")[1],

        employerESI: payrollData.employerESI,
        edliCharges: payrollData.edliCharges,
        adminCharges: payrollData.adminCharges,

        employeePf: payrollData.employeePf,

        employeeESI: payrollData.employeeESI,
        professionalTax:
          "Max Rs. 200 will be deducted if the Gross Salary is 25000 or above",

        lwf: payrollData.lwfValues.split("|")[0],
        lwfState: payrollData.lwfValues.split("|")[1],
        lwfDeductionFrequency: payrollData.lwfValues.split("|")[2],

        employeePfFixOrPro: payrollData.employeePf.split("|")[0],
        empPfChange:
          payrollData.employeePf.split("|")[1] == "3"
            ? payrollData.employeePf.split("|")[2]
            : "",
        employeePf: payrollData.employeePf.split("|")[1],

        employerLwf: payrollData.employerLwf?.split("|")[0],
        employerLwfState: payrollData.employerLwf?.split("|")[1],
        employerLwfDeductionFrequency: payrollData.employerLwf?.split("|")[2],
      }));

      setFromDate(splittedDate ? splittedDate[0] : "");
      setToDate(splittedDate ? splittedDate[1] : "");

      const empPf = payrollData.employeePf.split("|")[0] == "3" ? true : false;
      setCustomEmpPF(empPf);
    }
  }, []);

  const getAllowance = useCallback(() => {
    dispatch(commonGetDataOne(getAllowanceListPath));
    dispatch(commonGetDataTwo(getDeductionListPath));
    dispatch(commonGetDataThird(getCalendarMonthListPath));
  }, []);

  useEffect(() => {
    getAllowance();
  }, []);

  useEffect(() => {
    if (commonState.commonGetTwoSuccess) {
      const newArr = commonState.commonGetTwoData?.map((row) => {
        return { value: row.deductionId, label: row.deduction_name };
      });
      // setDeductionApiList(newArr);
    }
  }, [commonState.commonGetTwoSuccess]);

  const getPfVariable = useCallback(() => {
    dispatch(commonGetData(`${getEmpPfVariableListPath}${user?.user_id}`));
  }, []);

  useEffect(() => {
    getPfVariable();
  }, []);

  useEffect(() => {
    if (commonState.commonGetSuccess) {
      setPfVariableList(commonState.commonGetData[0]);
    }
    // if (commonState.commonGetThirdSuccess) {
    //   setCalendarMonthList(commonState.commonGetThirdData);
    // }
  }, [commonState]);

  const addEarningsField = (e) => {
    const { value, label } = e;

    setEarnings((prevEarnings) => {
      if (value === 3) {
        return [
          ...prevEarnings,
          {
            id: value,
            head: "",
            calculation: "",
            calculationType: "",
            type: "",
            salaryType: "",
          },
        ];
      }

      const isPresent = prevEarnings.some((earning) => earning.id === value);
      if (!isPresent) {
        return [
          ...prevEarnings,
          {
            id: value,
            head: label,
            calculation: "",
            calculationType: "",
            type: "",
          },
        ];
      }

      return prevEarnings;
    });
  };

  const updateEarnings = (index, e) => {
    const { name, value } = e.target;
    const list = [...earnings];
    list[index].head = value;
    setEarnings(list);
  };

  const removeEarningsFields = (e, index) => {
    e.preventDefault();
    const rows = [...earnings];
    rows.splice(index, 1);
    setEarnings(rows);
  };

  const checkPercentageValue = async (name, value) => {
    let total = earnings.reduce((acc, curr) => {
      if (curr.type?.trim() === "Percentage") {
        return acc + parseFloat(curr.calculation || 0);
      }
      return acc;
    }, 0);

    if (saveData.basicType === "Percentage") {
      total =
        (name == "basicPay"
          ? parseInt(value) + parseInt(total)
          : parseInt(saveData.basicPay) + parseInt(total)) || 0;
    }
    if (saveData.hraPayType === "Percentage") {
      total =
        (name == "hraPay"
          ? parseInt(value) + parseInt(total)
          : parseInt(saveData.hraPay) + parseInt(total)) || 0;
    }
    if (saveData.otherType === "Percentage") {
      total =
        (name == "otherAllowance"
          ? parseInt(value) + parseInt(total)
          : parseInt(saveData.otherAllowance) + parseInt(total)) || 0;
    }

    return total;
  };

  const checkPercentageValueOne = async (indexToSkip, value) => {
    let total = earnings.reduce((acc, curr, idx) => {
      if (idx === indexToSkip) return acc;
      if (curr.type?.trim() === "Percentage") {
        return acc + (parseFloat(curr.calculation) || 0);
      }
      return acc;
    }, 0);

    total += parseFloat(value) || 0;

    if (saveData.basicType === "Percentage") {
      total += parseFloat(saveData.basicPay) || 0;
    }
    if (saveData.hraPayType === "Percentage") {
      total += parseFloat(saveData.hraPay) || 0;
    }
    if (saveData.otherType === "Percentage") {
      total += parseFloat(saveData.otherAllowance) || 0;
    }

    return total;
  };

  const handleEarningsChanges = async (index, e) => {
    const { name, value } = e.target;
    const list = [...earnings];
    let nameType = list[index].type;

    if (name == "calculation" && nameType != "Fixed") {
      let per = await checkPercentageValueOne(index, value);
      // if (per > 100) {
      //   toast.error("Total percentage should not exceed 100%");
      // } else {
      list[index][name] = value;
      setEarnings(list);
      // }
    } else {
      list[index][name] = value;
      setEarnings(list);
    }
  };

  const handleEarningsRadioChanges = (index, e) => {
    const list = [...earnings];
    list[index].calculationType = e.target.value;
    setEarnings(list);
  };

  const handleEarningsTypeChanges = (index, e) => {
    const list = [...earnings];
    list[index].type = e.target.value;
    list[index].calculation = "";
    setEarnings(list);
  };

  const handleToggleLwfChange = (event) => {
    setSaveData((pre) => ({
      ...pre,
      [event.target.name]: event.target.checked,
      lwfState: "",
      lwfDeductionFrequency: "",
    }));
  };

  const handleToggleEmprLwfChange = (event) => {
    setSaveData((pre) => ({
      ...pre,
      [event.target.name]: event.target.checked,
      employerLwfState: "",
      employerLwfDeductionFrequency: "",
    }));
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    // if (value == "Custom") {
    //   setCustomEmpPF(true);
    //   setSaveData((pre) => ({
    //     ...pre,
    //     [name]: value,
    //   }));
    // } else {
    //   setCustomEmpPF(false);
    if (name == "basicType") {
      setSaveData((pre) => ({
        ...pre,
        basicPay: "",
      }));
    }

    if (name == "hraPayType") {
      setSaveData((pre) => ({
        ...pre,
        hraPay: "",
      }));
    }

    setSaveData((pre) => ({
      ...pre,
      [name]: value,
    }));
    // }
  };

  const handleBasicChange = (e) => {
    const { value, name } = e.target;
    if (value.length < 9) {
      setSaveData((pre) => ({
        ...pre,
        [name]: value,
      }));
    }
  };

  const handleSwitchChange = (e) => {
    const { value, name } = e.target;

    setSaveData((pre) => ({
      ...pre,
      [name]: value,
    }));
  };

  const handleChangeEmployeePf = (e) => {
    const { value, name } = e.target;
    if (value == "Custom") {
      setCustomEmpPF(true);
      setSaveData((pre) => ({
        ...pre,
        [name]: value,
      }));
    } else {
      if (value == "2") {
        const isExist = earnings.some((earning) => earning.id == "2");
        if (isExist) {
          const { value, name } = e.target;
          setSaveData((pre) => ({
            ...pre,
            [name]: value,
          }));
        } else {
          toast.error("There is no Dearness Allowance is selected");
        }
      } else {
        setCustomEmpPF(false);
        setSaveData((pre) => ({
          ...pre,
          [name]: value,
          empPfChange: "",
        }));
      }
    }
  };

  const handleEmployerChange = (e) => {
    const { value, name } = e.target;
    setSaveData((pre) => ({
      ...pre,
      [name]: value,
    }));
  };

  const handleEmpPfChange = (e) => {
    const { value, name } = e.target;
    if (value <= 2000) {
      setSaveData((pre) => ({
        ...pre,
        empPfChange: value,
      }));
    }
  };

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    setSaveData((pre) => ({
      ...pre,
      [name]: checked ? "1" : "0",
    }));
  };

  const addDeductionsField = (e) => {
    const { value, label } = e;
    setDeductions([
      ...deductions,
      {
        id: deductions.length + 1,
        head: label,
        calculation: "",
        calculationType: "",
        type: "",
        salaryType: "",
      },
    ]);
  };

  const removeDeductionsFields = (e, index) => {
    e.preventDefault();
    const rows = [...deductions];
    rows.splice(index, 1);
    setDeductions(rows);
  };

  const handleDeductionsChanges = (index, e) => {
    const { name, value } = e.target;
    const list = [...deductions];
    if (list[index].calculationType == "Percentage") {
      if (value <= 100) {
        list[index][name] = value;
        setDeductions(list);
      }
    } else {
      list[index][name] = value;
      setDeductions(list);
    }
  };

  const updateDeductions = (index, e) => {
    const { value } = e.target;
    const list = [...deductions];
    list[index].head = value;
    setDeductions(list);
  };

  const handleDeductionsRadioChanges = (index, e) => {
    // const list = [...deductions];
    // list[index].calculationType = e.target.checked ? "Fixed" : "Percentage";
    // setDeductions(list);

    const list = [...deductions];
    list[index].calculationType = e.target.value;
    setDeductions(list);
  };

  const handleDeductionsTypeChanges = (index, e) => {
    const list = [...deductions];
    list[index].type = e.target.value;
    setDeductions(list);
  };

  const [isOpen, setIsOpen] = useState(false);
  const [calendarType, setCalendarType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isToDateValidate, setIsToDateValidate] = useState(false);

  const dropdownFunc = () => {
    setIsOpen((prev) => !prev);
  };

  const handleCalendarMonthList = (id, name) => {
    setIsToDateValidate(false);
    setCalendarType(name);
    if (name == "CustomDateRange") {
      setFromDate("01");
      setToDate("02");
    } else {
      setFromDate("01");
      setToDate("31");
    }
    setSaveData((pre) => ({
      ...pre,
      attendanceCycle: name,
    }));
    document.querySelector(".selected-display").innerHTML =
      splitCamelCase(name);
  };

  const handleStartDate = (e) => {
    setIsToDateValidate(false);
    let { value } = e.target;
    if (value == 1) {
      if (calendarType == "CustomDateRange") {
        setFromDate("01");
        setToDate("02");
      } else {
        setFromDate("01");
        setToDate("31");
      }
    } else {
      if (calendarType == "CustomDateRange") {
        setFromDate(value);
        setToDate(parseInt(value) + 1);
      } else {
        setFromDate(value);
        let d = value - 1;
        let dd = d.length < 2 ? `0${d}` : d;
        setToDate(dd);
      }
    }
  };

  const handleEndDate = ({ target: { value } }) => {
    if (value === "") {
      setToDate("");
      return;
    }
    if (value > 31) {
      return;
    }
    setIsToDateValidate(false);
    let cleanValue = value.replace(/^0+/, "") || "0";
    setToDate(cleanValue);
  };

  const validateEndDate = () => {
    let endDate = Number(toDate);
    let startDate = Number(fromDate);

    if (calendarType === "CustomDateRange") {
      if (endDate <= startDate) {
        setIsToDateValidate(true);
        setToDate(String(startDate + 1));
      }
    }
  };

  const handlePayDays = ({ target: { name, value } }) => {
    setSaveData((pre) => ({
      ...pre,
      [name]: value,
    }));
  };

  // const handleCheckDearnessAllowance = ()

  const handleCheckDearnessAllowance = ({ target: { name, value } }) => {
    if (value == "2") {
      const isExist = earnings.some((earning) => earning.id == "2");
      if (isExist) {
        setSaveData((pre) => ({
          ...pre,
          [name]: value,
        }));
      } else {
        toast.error("There is no Dearness Allowance is selected");
      }
    } else {
      setSaveData((pre) => ({
        ...pre,
        [name]: value,
      }));
    }
  };

  const handleChangePay = async (e) => {
    const { value, name } = e.target;

    // if ((await checkPercentageValue(name, value)) > 100) {
    //   toast.error("Total percentage should not exceed 100%");
    // } else {
    setSaveData((pre) => ({
      ...pre,
      [name]: value,
    }));
    // }
  };

  const preSubmit = () => {
    document.getElementById("submitForm").click();
  };

  const handleSubmit = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      const allowanceList = [
        ...earnings.map((v) => ({
          [v.head]:
            v.salaryType == undefined
              ? v.calculation + "|" + v.type + "|" + v.calculationType
              : v.calculation +
                "|" +
                v.type +
                "|" +
                v.calculationType +
                "|" +
                v.salaryType,
        })),
        {
          "Other Allowance": saveData.otherAllowanceType,
        },
      ];

      // saveData.otherAllowance +
      // "|" +
      // saveData.otherType +
      // "|" +

      const newAllowanceList = deductions.map((v) => {
        return {
          [v.head]: v.calculation + "|" + v.type + "|" + v.calculationType,
        };
      });

      const calendarTypeVal =
        calendarType == "CustomDateRange"
          ? "CustomDate"
          : calendarType == "CalendarMonth"
          ? "CalendarMonth"
          : "FixedDate";

      let d = {
        path: updatePayrollModelPath,
        data: {
          userId: user.user_id,
          payrollModelId: saveData.payrollModelId,
          payrollModelName: saveData.templateName,
          basicPay:
            saveData.basicPay +
            "|" +
            saveData.basicType +
            "|" +
            saveData.basicPayType,
          hraPay:
            saveData.hraPay +
            "|" +
            saveData.hraPayType +
            "|" +
            saveData.hraType,
          attendanceCycle: `${calendarTypeVal}|${fromDate}-${toDate}`,
          payDays: saveData.payDays,
          otherAllowance:
            saveData.otherAllowance +
            "|" +
            saveData.otherAllowanceType +
            "|" +
            saveData.otherType,

          // employerPf: saveData.employerPf,
          employerPf: saveData.employerPfFixedOrPro + "|" + saveData.employerPf,

          employerESI: saveData.employerESI,
          edliCharges: saveData.edliCharges,
          adminCharges: saveData.adminCharges,

          employeePf: saveData.empPfChange
            ? saveData.employeePfFixOrPro + "|3|" + saveData.empPfChange
            : saveData.employeePfFixOrPro + "|" + saveData.employeePf,

          // employeePf: saveData.empPfChange
          //   ? "3|" + saveData.empPfChange
          //   : saveData.employeePf,

          lwf:
            saveData.lwf == "1"
              ? "1" +
                "|" +
                saveData.lwfState +
                "|" +
                saveData.lwfDeductionFrequency
              : "0",

          employerLwf:
            saveData.employerLwf == "1"
              ? "1" +
                "|" +
                saveData.employerLwfState +
                "|" +
                saveData.employerLwfDeductionFrequency
              : "0",
          employeeESI: saveData.employeeESI,
          allowanceList,
          newAllowanceList,
        },
      };
      dispatch(commonSaveData(d));
    }
  };

  useEffect(() => {
    if (commonState.commonSuccess || commonState.commonError) {
      commonState.commonSuccess
        ? toast.success(commonState.commonMessage)
        : toast.error(commonState.commonMessage);
      dispatch(initCommonState());
      setTimeout(() => {
        navigate("/payroll#payroll-configurations");
      }, 1000);
    }
  }, [commonState]);
  const setIsOpens = () => {
    if (isOpen == true) {
      setIsOpen(false);
    }
  };

  return (
    <div className="body-container mt-2">
      {saveData.payrollModelId ? (
        <div
          className="page-body"
          style={{
            position: "relative",
            height: "100%",
            maxHeight: "auto",
            top: "-10px",
          }}
          onClick={setIsOpens}
        >
          <Widgets
            body={
              <>
                <div
                  style={{
                    position: "relative",
                    width: "95%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                    marginTop: "-10px",
                  }}
                >
                  <Link
                    to="/payroll#payroll-configurations"
                    style={{
                      position: "relative",
                      left: "60px",
                      textDecoration: "none",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "10px",
                      marginBottom: "10px",
                      color: "black",
                      width: "200px",
                    }}
                  >
                    <ArrowBack
                      style={{
                        cursor: "pointer",
                      }}
                      className="color-white"
                    />
                    <span className="color-white">Update Model</span>
                  </Link>

                  <ButtonCom
                    type={"button"}
                    class_name={"p_btn universal-btn"}
                    text={
                      commonState.commonLoading
                        ? `Updating Model...`
                        : "Update Model"
                    }
                    url_or_onclick={preSubmit}
                    icon={null}
                    width={""}
                  />
                </div>

                <Form
                  noValidate
                  validated={validated}
                  onSubmit={handleSubmit}
                  style={{ width: "90%", margin: "0 auto" }}
                >
                  <Row className="gray-bg-4">
                    <h3 className="color-white">Module Details</h3>
                    <Col sm="6" className="mt-2">
                      <Form.Group>
                        <Form.Label>
                          <strong className="color-gray">Model Name</strong>
                        </Form.Label>

                        <Form.Control
                          name="templateName"
                          value={saveData.templateName}
                          onChange={handleChange}
                          placeholder="Model name"
                          required
                          className="universal-input"
                        />
                      </Form.Group>
                    </Col>
                    <Col sm="6" className="mt-2">
                      <label className="color-gray">
                        <strong>Attendance Cycle</strong>
                      </label>

                      <div
                        className={`wrapper_dropdown universal-input ${
                          isOpen ? "active" : null
                        } `}
                        id="dropdown"
                        onClick={dropdownFunc}
                        style={{
                          minHeight: "39px",
                          marginTop: "7px",
                          borderRadius: "5px",
                        }}
                      >
                        <span className="selected-display" id="destination">
                          {splitCamelCase(saveData.attendanceCycle)}
                        </span>
                        <svg
                          id="drp-arrow"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="arrow transition-all ml-auto rotate-180"
                          style={{ position: "relative", top: "-2px" }}
                        >
                          <path
                            d="M7 14.5l5-5 5 5"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>

                        {isOpen && (
                          <ul
                            className="dropdown"
                            // style={{
                            //   backgroundColor: "#080808",
                            //   color: "#fff",
                            // }}
                          >
                            {Array.isArray(calendarMonthList) &&
                              calendarMonthList.map((row, idx) => {
                                return (
                                  <li
                                    className={
                                      splitCamelCase(calendarType) === row.label
                                        ? "item active"
                                        : "item"
                                    }
                                    key={idx}
                                    style={{
                                      borderBottom: "1px solid lightgray",
                                    }}
                                    onClick={() =>
                                      handleCalendarMonthList(row.id, row.value)
                                    }
                                  >
                                    <div>{row.label} </div>
                                  </li>
                                );
                              })}
                          </ul>
                        )}
                      </div>
                    </Col>

                    <Col className="mt-2" sm="3">
                      <Form.Group>
                        <Form.Label className="color-gray">
                          Start Date
                        </Form.Label>
                        {(() => {
                          const rows = [];
                          for (let i = 1; i < 32; i++) {
                            rows.push(
                              <option value={i} key={i}>
                                {i}
                              </option>
                            );
                          }

                          return (
                            <Form.Select
                              value={fromDate}
                              onChange={handleStartDate}
                              style={{ color: "gray" }}
                              className="universal-input"
                            >
                              {rows}
                            </Form.Select>
                          );
                        })()}
                      </Form.Group>
                    </Col>

                    <Col className="mt-2" sm="3">
                      <Form.Group>
                        <Form.Label className="color-gray">End Date</Form.Label>

                        <Form.Control
                          placeholder="0"
                          value={toDate}
                          className="end-date universal-input"
                          onChange={handleEndDate}
                          onBlur={validateEndDate}
                          readOnly={
                            calendarType == "CustomDateRange" ? false : true
                          }
                        />
                      </Form.Group>
                      {isToDateValidate && (
                        <div
                          style={{
                            paddingRight: 11,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gap: "10px",
                          }}
                        >
                          <span style={{ color: "red" }}>
                            To Date must be greater than From Date
                          </span>
                        </div>
                      )}
                    </Col>
                    <Col sm="6" className="mt-2">
                      <Form.Group>
                        <Form.Label>
                          <strong className="color-gray">Pay Days</strong>
                        </Form.Label>
                        <Form.Select
                          name="payDays"
                          value={saveData.payDays}
                          onChange={handlePayDays}
                          required
                          className="universal-input"
                        >
                          <option value="">Select Pay Days</option>
                          <option value="TotalDaysInMonth">
                            Total Days in Month
                          </option>
                          <option value="WorkingHoliday">
                            Working Days + Holiday
                          </option>
                          <option value="WorkingWeekOff">
                            Working Days + Week Off
                          </option>
                          <option value="WorkingDays">Working Days</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="gray-bg-4 mt-2 mb-3">
                    <h3 className="color-white">Earnings</h3>

                    <Col className="mt-2" sm="4">
                      <Form.Group>
                        <Form.Label className="color-gray"> Basics</Form.Label>
                        <Form.Select
                          name="basicPayType"
                          onChange={handleToggleChange}
                          required
                          className="universal-input"
                        >
                          <option value=""> Select Basic Type </option>
                          <option
                            value="Fixed"
                            selected={
                              saveData.basicPayType == "Fixed" ? "selected" : ""
                            }
                          >
                            Fixed
                          </option>
                          <option
                            value="On Attendance"
                            selected={
                              saveData.basicPayType == "On Attendance"
                                ? "selected"
                                : ""
                            }
                          >
                            On Attendance
                          </option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col sm="4" className="mt-2">
                      <Form.Group>
                        <Form.Label className="color-gray">
                          Basic Option
                        </Form.Label>
                        <Form.Select
                          name="basicType"
                          value={saveData.basicType}
                          onChange={handleChange}
                          required
                          className="universal-input"
                        >
                          <option value="">Select option</option>
                          <option value="Fixed">Fixed</option>
                          <option value="Percentage">Percentage</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col
                      sm="4"
                      className="mt-2"
                      style={{ position: "relative" }}
                    >
                      <Form.Group>
                        <Form.Label className="color-gray">
                          Basic Amount
                        </Form.Label>
                        <Form.Control
                          type="number"
                          name="basicPay"
                          value={saveData.basicPay}
                          onChange={handleChangePay}
                          style={{
                            position: "relative",
                            color: "gray",
                            paddingLeft: "55px !important",
                          }}
                          placeholder={`Enter basic ${
                            saveData.basicType == "Fixed"
                              ? " fixed amount"
                              : saveData.basicType == "Percentage"
                              ? "percentage"
                              : "amount"
                          }`}
                          required
                          className="universal-input padding-left-20"
                        />
                        {saveData.basicType != "Percentage" && (
                          <BiRupee
                            className="input-icon"
                            style={{ left: "20px", top: "49px" }}
                          />
                        )}
                        {saveData.basicType == "Percentage" && (
                          <span
                            className="input-icon"
                            style={{ right: "30px", top: "48px" }}
                          >
                            %
                          </span>
                        )}
                      </Form.Group>
                    </Col>

                    {earnings.map((data, index) => {
                      const { id, head, calculation, calculationType, type } =
                        data;
                      return (
                        id == "2" && (
                          <>
                            <Col sm="4" className="mt-3">
                              <Form.Group>
                                {id == 3 ? (
                                  <Form.Control
                                    onChange={(e) => updateEarnings(index, e)}
                                    value={head}
                                    placeholder="Enter allowance"
                                    required
                                    className="universal-input"
                                  />
                                ) : (
                                  <Form.Label className="color-gray">
                                    {head}
                                  </Form.Label>
                                )}

                                <Form.Select
                                  name="calculationType"
                                  onChange={(e) =>
                                    handleEarningsRadioChanges(index, e)
                                  }
                                  required
                                  className="universal-input"
                                >
                                  <option value=""> Select {head} Type </option>
                                  <option
                                    value="Fixed"
                                    selected={
                                      calculationType == "Fixed"
                                        ? "selected"
                                        : ""
                                    }
                                  >
                                    Fixed
                                  </option>
                                  <option
                                    value="On Attendance"
                                    selected={
                                      calculationType == "On Attendance"
                                        ? "selected"
                                        : ""
                                    }
                                  >
                                    On Attendance
                                  </option>
                                </Form.Select>
                              </Form.Group>
                            </Col>

                            {/* {calculationType == "On Attendance" && ( */}
                            <Col sm="4" className="mt-3">
                              <Form.Group>
                                <Form.Label className="color-gray">
                                  {head} option
                                </Form.Label>
                                <Form.Select
                                  name="type"
                                  value={type}
                                  onChange={(e) =>
                                    handleEarningsTypeChanges(index, e)
                                  }
                                  required
                                  className="universal-input"
                                >
                                  <option value="">Select option</option>
                                  <option value="Fixed">Fixed</option>
                                  <option value="Percentage">Percentage</option>
                                </Form.Select>
                              </Form.Group>
                            </Col>
                            {/* )} */}

                            <Col
                              sm="3"
                              className="mt-3"
                              style={{
                                position: "relative",
                              }}
                            >
                              <Form.Group>
                                <Form.Label className="color-gray">
                                  {head} Amount
                                </Form.Label>
                                <Form.Control
                                  type="number"
                                  name="calculation"
                                  value={calculation}
                                  onChange={(e) =>
                                    handleEarningsChanges(index, e)
                                  }
                                  placeholder={`Enter ${
                                    type == "Fixed"
                                      ? "fixed amount"
                                      : type == "Percentage"
                                      ? "percentage"
                                      : "amount"
                                  }`}
                                  style={{
                                    color: "gray",
                                  }}
                                  required
                                  className="universal-input padding-left-20"
                                />
                                {type != "Percentage" && (
                                  <BiRupee
                                    className="input-icon"
                                    style={{ left: "20px", top: "49px" }}
                                  />
                                )}
                                {type == "Percentage" && (
                                  <span
                                    className="input-icon"
                                   style={{ right: "30px", top: "48px" }}
                                  >
                                    %
                                  </span>
                                )}
                              </Form.Group>
                            </Col>
                            <Col sm="1" className="mt-2">
                              <RiDeleteBin5Line
                                className="remove-icon"
                                onClick={(e) => removeEarningsFields(e, index)}
                                style={{
                                  position: "relative",
                                  cursor: "pointer",
                                  float: "right",
                                  top: "42px",
                                }}
                              />
                            </Col>
                          </>
                        )
                      );
                    })}

                    <Col
                      sm="4"
                      className="mt-3"
                      style={{ position: "relative" }}
                    >
                      <Form.Group
                        style={{
                          position: "relative",
                        }}
                      >
                        <Form.Label className="color-gray">HRA Type</Form.Label>
                        <Form.Select
                          name="hraType"
                          onChange={handleToggleChange}
                          required
                          className="universal-input"
                        >
                          <option value=""> Select HRA Type </option>
                          <option
                            value="Fixed"
                            selected={
                              saveData.hraType == "Fixed" ? "selected" : ""
                            }
                          >
                            Fixed
                          </option>
                          <option
                            value="On Attendance"
                            selected={
                              saveData.hraType == "On Attendance"
                                ? "selected"
                                : ""
                            }
                          >
                            On Attendance
                          </option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col
                      sm="4"
                      className="mt-3"
                      style={{ position: "relative" }}
                    >
                      <Form.Group>
                        <Form.Label className="color-gray">
                          HRA Options
                        </Form.Label>
                        <Form.Select
                          name="hraPayType"
                          value={saveData.hraPayType}
                          onChange={handleChange}
                          required
                          className="universal-input"
                        >
                          <option value="">Select option</option>
                          <option value="Fixed">Fixed</option>
                          <option value="Percentage">Percentage</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col
                      sm="4"
                      className="mt-3"
                      style={{ position: "relative" }}
                    >
                      <Form.Group>
                        <Form.Label className="color-gray">
                          HRA Amount
                        </Form.Label>
                        <Form.Control
                          type="number"
                          name="hraPay"
                          value={saveData.hraPay}
                          onChange={handleChangePay}
                          style={{ color: "gray", paddingLeft: "25px" }}
                          placeholder={`Enter HRA ${
                            saveData.hraPayType == "Fixed"
                              ? " fixed amount"
                              : saveData.hraPayType == "Percentage"
                              ? "percentage"
                              : "amount"
                          }`}
                          required
                          className="universal-input padding-left-20"
                        />
                        {saveData.hraPayType != "Percentage" && (
                          <BiRupee
                            className="input-icon"
                            style={{ left: "20px", top: "49px" }}
                          />
                        )}
                        {saveData.hraPayType == "Percentage" && (
                          <span
                            className="input-icon"
                            style={{ right: "30px", top: "48px" }}
                          >
                            %
                          </span>
                        )}
                      </Form.Group>
                    </Col>

                    {earnings.map((data, index) => {
                      const {
                        id,
                        head,
                        calculation,
                        calculationType,
                        type,
                        salaryType,
                      } = data;
                      return (
                        id != "2" && (
                          <>
                            <Col className="mt-3" sm="4">
                              <Form.Group>
                                {id == 3 ? (
                                  <Form.Control
                                    onChange={(e) => updateEarnings(index, e)}
                                    value={head}
                                    placeholder="Enter allowance"
                                    required
                                    className="universal-input"
                                  />
                                ) : (
                                  <Form.Label className="color-gray">
                                    {head}
                                  </Form.Label>
                                )}

                                <Form.Select
                                  name="calculationType"
                                  onChange={(e) =>
                                    handleEarningsRadioChanges(index, e)
                                  }
                                  required
                                  className="universal-input"
                                >
                                  <option value="">
                                    {" "}
                                    Select Allowance Type{" "}
                                  </option>{" "}
                                  {/*{head}*/}
                                  <option
                                    value="Fixed"
                                    selected={
                                      calculationType == "Fixed"
                                        ? "selected"
                                        : ""
                                    }
                                  >
                                    Fixed
                                  </option>
                                  <option
                                    value="On Attendance"
                                    selected={
                                      calculationType == "On Attendance"
                                        ? "selected"
                                        : ""
                                    }
                                  >
                                    On Attendance
                                  </option>
                                </Form.Select>
                              </Form.Group>
                            </Col>

                            {/* {calculationType == "On Attendance" && ( */}
                            <Col
                              className="mt-3"
                              sm={type == "Percentage" ? "2" : "4"}
                            >
                              <Form.Group>
                                <Form.Label className="color-gray">
                                  {head} option
                                </Form.Label>
                                <Form.Select
                                  name="type"
                                  value={type}
                                  onChange={(e) =>
                                    handleEarningsTypeChanges(index, e)
                                  }
                                  required
                                  className="universal-input"
                                >
                                  <option value="">Select Option</option>
                                  <option
                                    selected={type == "Fixed" ? "selected" : ""}
                                    value="Fixed"
                                  >
                                    Fixed
                                  </option>
                                  <option
                                    selected={
                                      type == "Percentage" ? "selected" : ""
                                    }
                                    value="Percentage"
                                  >
                                    Percentage
                                  </option>
                                </Form.Select>
                              </Form.Group>
                            </Col>
                            {/* )} */}
                            {type == "Percentage" && (
                              <Col
                                sm="2"
                                className="mt-3"
                                style={{ position: "relative" }}
                              >
                                <Form.Group>
                                  <Form.Label className="color-gray">
                                    {head} Rate
                                  </Form.Label>
                                  <Form.Select
                                    name="salaryType"
                                    value={salaryType}
                                    onChange={(e) =>
                                      handleEarningsChanges(index, e)
                                    }
                                    required
                                    className="universal-input"
                                  >
                                    <option value="">Select Rate</option>
                                    <option
                                      value="Basic"
                                      selected={
                                        salaryType == "Percentage"
                                          ? "selected"
                                          : ""
                                      }
                                    >
                                      Basic Salary x (Percentage Rate)
                                    </option>
                                    <option
                                      value="Gross"
                                      selected={
                                        salaryType == "Percentage"
                                          ? "selected"
                                          : ""
                                      }
                                    >
                                      Gross Salary x (Percentage Rate)
                                    </option>
                                  </Form.Select>
                                </Form.Group>
                              </Col>
                            )}
                            <Col
                              sm="3"
                              className="mt-3"
                              style={{
                                position: "relative",
                              }}
                            >
                              <Form.Group
                                style={{
                                  position: "relative",
                                }}
                              >
                                <Form.Label className="color-gray">
                                  {head} Amount
                                </Form.Label>
                                <Form.Control
                                  type="number"
                                  name="calculation"
                                  value={calculation}
                                  onChange={(e) =>
                                    handleEarningsChanges(index, e)
                                  }
                                  placeholder={`Enter ${
                                    type == "Fixed"
                                      ? "fixed amount"
                                      : type == "Percentage"
                                      ? "percentage"
                                      : "amount"
                                  }`}
                                  style={{
                                    color: "gray",
                                  }}
                                  required
                                  className="universal-input padding-left-20"
                                />

                                {type != "Percentage" && (
                                  <BiRupee
                                    className="input-icon"
                                    style={{ left: "8px", top: "49px" }}
                                  />
                                )}
                                {type == "Percentage" && (
                                  <span
                                    className="input-icon"
                                    style={{ right: "30px", top: "48px" }}
                                  >
                                    %
                                  </span>
                                )}
                              </Form.Group>
                            </Col>
                            <Col sm="1" className="mt-2">
                              <RiDeleteBin5Line
                                className="remove-icon"
                                onClick={(e) => removeEarningsFields(e, index)}
                                style={{
                                  position: "relative",
                                  cursor: "pointer",
                                  float: "right",
                                  top: "42px",
                                }}
                              />
                            </Col>
                          </>
                        )
                      );
                    })}
                  </Row>

                  <Row className="gray-bg-4 mt-2 mb-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <h3 className="color-white">Other Allowance</h3>
                      <FormControl style={{ width: "220px" }} required>
                        <Select
                          styles={customStyles}
                          value={"Add Allowance"}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          options={allowance}
                          onChange={addEarningsField}
                          placeholder={
                            <div
                              className="add-text"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                backgroundColor: "transparent",
                                color: "#fff",
                                marginTop: "-10px",
                              }}
                            >
                              <IoIosAdd className="add-icon color-white" /> Add
                              Allowance
                            </div>
                          }
                          style={{ border: "none" }}
                          className="universal-btn color-white height_40"
                        />
                      </FormControl>
                    </div>
                    <Col sm="4" className="mt-2">
                      <Form.Group
                        style={{
                          position: "relative",
                        }}
                      >
                        <Form.Label className="color-gray">
                          Other Allowance Type
                        </Form.Label>
                        <Form.Select
                          name="otherAllowanceType"
                          onChange={handleToggleChange}
                          required
                          className="universal-input"
                        >
                          <option value="">
                            {" "}
                            Select Other Allowance Type{" "}
                          </option>
                          <option
                            value="Fixed"
                            selected={
                              saveData.otherAllowanceType == "Fixed"
                                ? "selected"
                                : ""
                            }
                          >
                            Fixed
                          </option>
                          <option
                            value="On Attendance"
                            selected={
                              saveData.otherAllowanceType == "On Attendance"
                                ? "selected"
                                : ""
                            }
                          >
                            On Attendance
                          </option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col sm="4" className="mt-3">
                      <p className="mt-3 color-white">
                        System Calculated
                        <Tooltip
                          title=" Automatically calculated from other allowance components."
                          arrow
                          placement="top"
                          slots={{
                            transition: Zoom,
                          }}
                          followCursor
                        >
                          <span>
                            <FiInfo className="info-icon" />
                          </span>
                        </Tooltip>
                      </p>
                    </Col>
                  </Row>

                  <Row className="gray-bg-4 mt-2 mb-3">
                    <h3 className="color-white">Statutory Deduction</h3>
                    <Col sm="6" className="mt-3">
                      <Form.Group>
                        <Form.Label className="color-gray">
                          Employee PF
                        </Form.Label>
                        <Form.Select
                          name="employeePfFixOrPro"
                          value={saveData.employeePfFixOrPro}
                          style={{ width: "100%" }}
                          onChange={handleChange}
                          required
                          className="universal-input"
                        >
                          <option value="">Select PF</option>
                          <option value="Fixed">Fixed</option>
                          <option value="Prorata">Prorata Basis</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col sm="6" className="mt-3">
                      <Form.Group>
                        <Form.Label className="color-gray">
                          Employee PF
                        </Form.Label>
                        <div>
                          <Form.Select
                            name="employeePf"
                            value={saveData.employeePf}
                            style={{ width: "100%" }}
                            onChange={handleChangeEmployeePf}
                            required={customEmpPF ? false : true}
                            className="universal-input"
                          >
                            <option value="">Select PF</option>
                            <option value="1">
                              12% on Basic Salary Max Rs. 1800
                            </option>
                            <option value="2">
                              12% on Basic + DA Salary Max Rs. 1800
                            </option>
                            <option
                              value="Custom"
                              selected={customEmpPF ? "selected" : null}
                            >
                              Custom
                            </option>
                          </Form.Select>
                          {customEmpPF ? (
                            <Form.Control
                              className="mt-3 universal-input"
                              name="employeePf"
                              value={saveData.empPfChange}
                              style={{ width: "100%" }}
                              onChange={handleEmpPfChange}
                              required
                              placeholder="Enter custom PF amount"
                            />
                          ) : null}
                        </div>
                      </Form.Group>
                    </Col>
                    <Col sm="6" className="mt-3">
                      <Form.Group>
                        <Form.Label className="color-gray">
                          Employee ESI
                        </Form.Label>
                        <p
                          name="employeeESI"
                          style={{
                            width: "100%",
                            textWrap: "wrap",
                            border: "1px solid lightgray",
                            borderRadius: "5px",
                            padding: "5px",
                            color: "gray",
                          }}
                        >
                          {saveData.employeeESI}
                        </p>
                      </Form.Group>
                    </Col>
                    <Col sm="6" className="mt-3">
                      <Form.Group>
                        <Form.Label className="color-gray">
                          Professional Tax
                        </Form.Label>
                        <p
                          name="professionalTax"
                          style={{
                            width: "100%",
                            textWrap: "wrap",
                            border: "1px solid lightgray",
                            borderRadius: "5px",
                            padding: "5px",
                            color: "gray",
                          }}
                        >
                          {saveData.professionalTax}
                        </p>
                      </Form.Group>
                    </Col>
                    <Col sm="6" className="mt-3">
                      <div className="d-flex flex-column item-aligns-center justify-content-start">
                        <div className="d-flex item-aligns-center justify-content-between">
                          <strong className="color-white">LWF</strong>
                          <Form.Group style={{ marginTop: " -7px" }}>
                            <Switch
                              name="lwf"
                              checked={saveData.lwf}
                              onChange={handleToggleLwfChange}
                              inputProps={{ "aria-label": "controlled" }}
                            />
                          </Form.Group>
                        </div>

                        <Row>
                          {saveData.lwf == "1" && (
                            <>
                              <Col sm="6">
                                <Form.Group>
                                  <Form.Select
                                    name="lwfState"
                                    value={saveData.lwfState}
                                    style={{ width: "100%" }}
                                    onChange={handleChange}
                                    required
                                    className="universal-input"
                                  >
                                    <option value="">Select State</option>
                                    <option value="1">Karnataka</option>
                                    <option value="2">Maharastra</option>
                                    <option value="3">Tamil Nadu</option>
                                  </Form.Select>
                                </Form.Group>
                              </Col>

                              <Col sm="6">
                                <Form.Group>
                                  <Form.Select
                                    name="lwfDeductionFrequency"
                                    value={saveData.lwfDeductionFrequency}
                                    style={{ width: "100%" }}
                                    onChange={handleChange}
                                    required
                                    className="universal-input"
                                  >
                                    <option value="">Select Deduction</option>
                                    {(saveData.lwfState == "1" ||
                                      saveData.lwfState == "3") && (
                                      <option value="monthly">Monthly</option>
                                    )}
                                    {saveData.lwfState == "2" && (
                                      <option value="half-yearly">
                                        Half - Yearly
                                      </option>
                                    )}
                                    {saveData.lwfState == "3" && (
                                      <option value="yearly">Yearly</option>
                                    )}
                                  </Form.Select>
                                </Form.Group>
                              </Col>
                            </>
                          )}
                        </Row>
                      </div>
                    </Col>

                    <Col sm="6" className="mt-3">
                      <div className="d-flex flex-column item-aligns-center justify-content-start">
                        <div className="d-flex item-aligns-center justify-content-between">
                          <strong className="color-white">TDS</strong>
                          <Form.Group className="color-white">
                            System Calculated
                            <Tooltip
                              title=" Automatically calculated from TDS components."
                              arrow
                              placement="top"
                              slots={{
                                transition: Zoom,
                              }}
                              followCursor
                            >
                              <span>
                                <FiInfo className="info-icon" />
                              </span>
                            </Tooltip>
                          </Form.Group>
                        </div>
                        <Row></Row>
                      </div>
                    </Col>
                  </Row>

                  <Row className="gray-bg-4 mt-2 mb-3">
                    <h3 className="color-white">Employer Contributions</h3>
                    <Col sm="6" className="mt-3">
                      <Form.Group>
                        <Form.Label className="color-gray">
                          Employer PF Type
                        </Form.Label>
                        <Form.Select
                          name="employerPfFixedOrPro"
                          value={saveData.employerPfFixedOrPro}
                          style={{ width: "100%" }}
                          onChange={handleEmployerChange}
                          required
                          className="universal-input"
                        >
                          <option value="">Select PF</option>
                          <option value="Fixed">Fixed</option>
                          <option value="Prorata">Prorata Basis</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col sm="6" className="mt-3">
                      <Form.Group>
                        <Form.Label className="color-gray">
                          Employer PF
                        </Form.Label>
                        <Form.Select
                          name="employerPf"
                          value={saveData.employerPf}
                          style={{ width: "100%" }}
                          onChange={handleCheckDearnessAllowance}
                          required
                          className="universal-input"
                        >
                          <option value="">Select PF</option>
                          <option value="1">
                            12% on Basic Salary Max Rs. 1800
                          </option>
                          <option value="2">
                            12% on Basic + DA Salary Max Rs. 1800
                          </option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col sm="6" className="mt-3">
                      <Form.Label className="color-gray">
                        Employer ESI
                      </Form.Label>
                      <p
                        name="employerESI"
                        style={{
                          width: "100%",
                          textWrap: "wrap",
                          border: "1px solid lightgray",
                          borderRadius: "5px",
                          padding: "5px",
                          color: "gray",
                        }}
                      >
                        {saveData.employerESI}
                      </p>
                    </Col>
                    <Col sm="6" style={{ marginTop: "30px" }}>
                      <div className="d-flex flex-column justify-content-start">
                        <div className="d-flex align-items-center justify-content-between">
                          <strong className="color-white">LWF</strong>

                          <Form.Group>
                            <Switch
                              name="employerLwf"
                              checked={saveData.employerLwf}
                              onChange={handleToggleEmprLwfChange}
                              inputProps={{ "aria-label": "controlled" }}
                            />
                          </Form.Group>
                        </div>

                        {saveData.employerLwf == "1" && (
                          <Row>
                            <Col sm="6">
                              <Form.Group>
                                <Form.Select
                                  name="employerLwfState"
                                  value={saveData.employerLwfState}
                                  style={{ width: "100%" }}
                                  onChange={handleChange}
                                  required
                                  className="universal-input"
                                >
                                  <option value="">Select State</option>
                                  <option value="1">Karnataka</option>
                                  <option value="2">Maharastra</option>
                                  <option value="3">Tamil Nadu</option>
                                </Form.Select>
                              </Form.Group>
                            </Col>

                            <Col sm="6">
                              <Form.Group>
                                <Form.Select
                                  name="employerLwfDeductionFrequency"
                                  value={saveData.employerLwfDeductionFrequency}
                                  style={{ width: "100%" }}
                                  onChange={handleChange}
                                  required
                                  className="universal-input"
                                >
                                  <option value="">Select Deduction</option>
                                  {(saveData.employerLwfState == "1" ||
                                    saveData.employerLwfState == "3") && (
                                    <option value="monthly">Monthly</option>
                                  )}
                                  {saveData.employerLwfState == "2" && (
                                    <option value="half-yearly">
                                      Half - Yearly
                                    </option>
                                  )}
                                  {saveData.employerLwfState == "3" && (
                                    <option value="yearly">Yearly</option>
                                  )}
                                </Form.Select>
                              </Form.Group>
                            </Col>
                          </Row>
                        )}
                      </div>
                    </Col>
                    <Col
                      sm="6"
                      className="mt-3 d-flex align-items-center justify-content-between"
                    >
                      <strong className="color-white">EDLI Charges</strong>
                      <Form.Group className="">
                        <input
                          name="edliCharges"
                          value={saveData.edliCharges}
                          onChange={handleCheckbox}
                          type="checkbox"
                          style={{
                            height: "20px",
                            width: "20px",
                          }}
                          checked={
                            saveData.edliCharges == "1" ? "checked" : null
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col
                      sm="6"
                      className="mt-3 d-flex align-items-center justify-content-between"
                    >
                      <strong className="color-white">Admin Charges</strong>
                      <Form.Group className="">
                        <input
                          name="adminCharges"
                          value={saveData.adminCharges}
                          onChange={handleCheckbox}
                          type="checkbox"
                          style={{
                            height: "20px",
                            width: "20px",
                          }}
                          checked={
                            saveData.adminCharges == "1" ? "checked" : null
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="gray-bg-4 mt-2 mb-3">
                    <Col
                      sm="12"
                      className="d-flex align-items-center justify-content-between"
                    >
                      <strong className="color-white">Allowance</strong>

                      <Button
                        type="button"
                        onClick={addDeductionsField}
                        style={{
                          backgroundColor: "#fff",
                          color: "skybule",
                          border: "1px solid lightgray",
                          borderRadius: "12px",
                        }}
                        className="universal-btn color-white height_40"
                      >
                        <div
                          className="add-text"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            color: "#fff",
                          }}
                        >
                          <IoIosAdd className="add-icon color-white" /> Add
                          Allowance
                        </div>
                      </Button>
                    </Col>

                    {deductions?.length > 0 ? (
                      <>
                        <Col sm="3" className="mt-2">
                          <Form.Group>
                            <Form.Label className="color-gray">
                              Allowance Name
                            </Form.Label>
                          </Form.Group>
                        </Col>

                        <Col sm="3" className="mt-2">
                          <Form.Group>
                            <Form.Label
                              className="color-gray"
                              style={{ marginLeft: "-5px" }}
                            >
                              Allowance Type
                            </Form.Label>
                          </Form.Group>
                        </Col>

                        <Col sm="3" className="mt-2">
                          <Form.Group>
                            <Form.Label
                              className="color-gray"
                              style={{ marginLeft: "-10px" }}
                            >
                              Allowance Options
                            </Form.Label>
                          </Form.Group>
                        </Col>

                        <Col sm="3" className="mt-2">
                          <Form.Group>
                            <Form.Label
                              className="color-gray"
                              style={{ marginLeft: "-17px" }}
                            >
                              Allowance Amount
                            </Form.Label>
                          </Form.Group>
                        </Col>
                      </>
                    ) : null}

                    {deductions?.map((data, index) => {
                      const {
                        head,
                        calculation,
                        calculationType,
                        type,
                        salaryType,
                      } = data;
                      return (
                        <Row
                          className="display-center"
                          key={index}
                          style={{ marginTop: index == 0 ? "-10px" : 0 }}
                        >
                          <Col className="mt-2" sm="3">
                            <Form.Control
                              onChange={(e) => updateDeductions(index, e)}
                              value={head}
                              placeholder="Enter allowance"
                              required
                              className="universal-input"
                            />
                          </Col>

                          <Col
                            sm={"3"}
                            className="mt-2"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "10px",
                            }}
                          >
                            <Form.Group
                              style={{
                                position: "relative",
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                gap: "5px",
                              }}
                            >
                              <Form.Select
                                name="calculationType"
                                onChange={(e) =>
                                  handleDeductionsRadioChanges(index, e)
                                }
                                className="universal-input"
                              >
                                <option value=""> Select {head} Type </option>
                                <option
                                  value="Fixed"
                                  selected={
                                    calculationType == "Fixed" ? "selected" : ""
                                  }
                                >
                                  Fixed
                                </option>
                                <option
                                  value="On Attendance"
                                  selected={
                                    calculationType == "On Attendance"
                                      ? "selected"
                                      : ""
                                  }
                                >
                                  On Attendance
                                </option>
                              </Form.Select>
                            </Form.Group>
                          </Col>

                          <Col
                            sm="3"
                            className="mt-2"
                            style={{ position: "relative" }}
                          >
                            <Form.Group>
                              <Form.Select
                                name="type"
                                value={type}
                                onChange={(e) =>
                                  handleDeductionsTypeChanges(index, e)
                                }
                                className="universal-input"
                              >
                                <option value="">Select Option</option>
                                <option
                                  selected={type == "Fixed" ? "selected" : ""}
                                  value="Fixed"
                                >
                                  Fixed
                                </option>
                                <option
                                  selected={
                                    type == "Percentage" ? "selected" : ""
                                  }
                                  value="Percentage"
                                >
                                  Percentage
                                </option>
                              </Form.Select>
                            </Form.Group>
                          </Col>

                          <Col
                            sm="3"
                            className="mt-2"
                            style={{
                              position: "relative",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "10px",
                            }}
                          >
                            <Form.Control
                              type="number"
                              name="calculation"
                              value={calculation}
                              onChange={(e) =>
                                handleDeductionsChanges(index, e)
                              }
                              placeholder={`Enter ${
                                type == "Fixed"
                                  ? "fixed amount"
                                  : type == "Percentage"
                                  ? "percentage"
                                  : "amount"
                              }`}
                              style={{
                                color: "gray",
                                width: "80%",
                                paddingLeft: "25px",
                              }}
                              required
                              className="universal-input-one"
                            />

                            {type != "Percentage" && (
                              <BiRupee
                                className="input-icon"
                                style={{ left: "20px" }}
                              />
                            )}
                            {type == "Percentage" && (
                              <span
                                className="input-icon"
                                style={{ right: "90px", top: "20px" }}
                              >
                                %
                              </span>
                            )}

                            <RiDeleteBin5Line
                              className="remove-icon"
                              onClick={(e) => removeDeductionsFields(e, index)}
                              style={{ cursor: "pointer" }}
                            />
                          </Col>
                        </Row>
                      );
                    })}
                  </Row>

                  <button
                    type="submit"
                    id="submitForm"
                    style={{ display: "none" }}
                  ></button>
                  <button
                    type="submit"
                    id="submitForm"
                    style={{ display: "none" }}
                  ></button>
                </Form>
              </>
            }
          />
        </div>
      ) : (
        "Data Loading..."
      )}

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
    </div>
  );
};

export default SalaryTemplate;
